import React from 'react';

export default function Footer() {
  return (
    <div className="">
      <div className="hidden sm:block" aria-hidden="true">
        <div className="py-2">
          <div className="border-t border-gray-200" />
        </div>
      </div>
      <div className="flex items-center justify-center h-16 text-gray-600">
        © 2022 Shoppers Inc. All rights reserved. Privacy Policy
      </div>
    </div>
  );
}
